import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";
import Want from "../views/Want.vue";
import Bill from "../views/Bill.vue";
import Preview from "../views/Preview.vue";
import New from "../views/New.vue";
import Disney from "../views/Disney";
import CurrencyCoupon from "../views/currencyCoupon";
import Pact from "../views/Pact";
import ShortChain from "../views/shortChain"
import MerchantLink from '../views/MerchantLink' // 商户端动态链接

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home
  },
  {
    path: "/other", // 同抽奖页面逻辑，只不展示活动规则
    name: "Home",
    component: Home
  },
  {
    path: "/want",
    name: "Want",
    component: Want
  },
  {
    path: "/bill",
    name: "Bill",
    component: Bill
  },
  {
    path: "/preview",
    name: "Preview",
    component: Preview
  },
  {
    path: "/new",
    name: "New",
    component: New
  },
  {
    path: "/disney",
    name: "Disney",
    component: Disney
  },
  {
    path: "/currencyCoupon",
    name: "CurrencyCoupon",
    component: CurrencyCoupon
  },
  {
    path: "/pact",
    name: "Pact",
    component: Pact
  },
  {
    path: "/shortChain",
    name: "ShortChain",
    component: ShortChain
  },
  {
    path: '/merchantlink',
    name: 'MerchantLink',
    component: MerchantLink
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

export default router;
